import { z } from 'zod';

import { isPasswordValid } from './password-rules';

export const phoneSchema = z.string().regex(/^\d{10}$/, 'Enter a valid 10-digit US phone number');
export const otpSchema = z.string().regex(/^\d{6}$/, 'Enter the 6-digit code');

// Flat Grower profile (see plan §1 decision 6) — no role union.
export const userSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string().nullish(),
  phone: z.string().nullish(),
});

export const loginPasswordSchema = z.object({
  phone: phoneSchema,
  password: z.string().min(1, 'Password is required'),
});

export const sendOtpSchema = z.object({
  phone: phoneSchema,
});

export const newPasswordSchema = z
  .object({
    newPassword: z.string().refine(isPasswordValid, 'Password does not meet the requirements'),
    confirmPassword: z.string(),
  })
  .refine((v) => v.newPassword === v.confirmPassword, {
    message: 'Passwords do not match.',
    path: ['confirmPassword'],
  });
